
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 6v3.46l1 .978V5.125c0-.375-.188-.781-.469-1.063L9.937.47C9.658.188 9.25 0 8.876 0H4C2.875 0 2 .906 2 2v12c0 1.125.875 2 2 2h1.115a4.68 4.68 0 01-.038-.597c0-.136.007-.27.02-.403H4c-.563 0-1-.438-1-1V2c0-.531.438-1 1-1h4v3.5C8 5.344 8.656 6 9.5 6H13zm-.031-1a1.259 1.259 0 01-.023-.049c-.025-.056-.054-.122-.102-.17L9.219 1.156c-.048-.047-.114-.077-.17-.102L9 1.03V4.5c0 .281.219.5.5.5h3.469z","fill":"#000"}}),_c('path',{attrs:{"d":"M10.537 15.5l3-3-3-3M6.5 15.366V14.5a2 2 0 012-2H13","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    